export default "__VITE_ASSET__78404b64__"